import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import DatePicker from 'react-bootstrap-datetimepicker'
import { pipe, tap, when, and, always } from 'ramda'

export const format = 'YYYY-MM-DD - HH:mm'

export const fromUnix = value => moment(value).format(format)
export const toUnix = value =>
  moment(value, format)
    .utc()
    .valueOf()

const DatePickerField = ({
  input: { value, onChange, ...input },
  meta: { touched, error }
}) => (
  <div
    className={when(and(error, touched), always('has-error'))}
    style={{ borderRadius: '2px' }}
  >
    <DatePicker
      inputProps={{
        name: input.name,
        ...input,
        onBlur: input.onBlur.bind(input, value)
      }}
      inputFormat={format}
      format={format}
      onChange={pipe(toUnix, tap(input.onBlur), onChange)}
      dateTime={fromUnix(value)}
      value={value}
    />
  </div>
)

DatePickerField.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any
}

export default DatePickerField



// WEBPACK FOOTER //
// ./src/components/form/datepicker/index.js